import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import NutritionalGuidance from './NutritionalGuidance';

export default function Blog() {
  return (
    <>
        <Navbar />
        <NutritionalGuidance />
        <Footer />
        <Copyright />
    </>
  )
}